import { gql } from '@apollo/client'

import {
  AccountDetailsView as QueryData,
  AccountDetailsViewVariables as QueryVariables,
} from 'types/gql-types/AccountDetailsView'

import { AccountDetailsViewValue } from '../AccountDetailsViewValue'

export const query = gql`
  query AccountDetailsView($id: ID!) {
    account: getDebitCardAccountV2(debitCardAccountUuid: $id) {
      __typename
      id
      ...AccountDetailsViewValueDebitCardAccountV2Fragment
    }
  }

  ${AccountDetailsViewValue.fragments.DebitCardAccountV2}
`

export const queryData = undefined as unknown as QueryData
export const queryVariables = undefined as unknown as QueryVariables

export type { QueryData, QueryVariables }
